export default function headerHome() {

    /*---------------------/ 0 - Function /------------------------*/
    function openCloseMenu() {
        const menu = document.querySelector('#menu--mobile')
        menu.classList.toggle("isOpen")
    }

    /*-------------------/ 1 - Buttons /--------------------------*/
    // Header - Open
    const btnOpen = document.querySelector("header #btn--open")
    btnOpen.addEventListener("click", openCloseMenu)

    // Menu - Close
    const btnClose = document.querySelector(".menu--container #btn--close")
    btnClose.addEventListener("click", openCloseMenu)

    /*-------------------/ 2 - Selected Anchor /----------------------*/

    const anchorLinks = document.querySelectorAll(".menu--container .anchor--link")
    anchorLinks.forEach(anchor => {

        anchor.addEventListener('click', (elementClicked) => {
            anchorLinks.forEach(elementRemove => {
                elementRemove.parentNode.classList.remove('isSelected')
            })

            elementClicked.target.parentNode.classList.add('isSelected')
        })
    })

}   